module.exports = __webpack_public_path__ + "img/safety_supervision.8f0f8acc.png";